export function getTotalOfTypes(prop, parts, t) {
  let total = ""
  let dic = {}
  parts
  .forEach(rp => {
    if (rp.diagnosticInfo) {
      const types = rp.diagnosticInfo.pricesOrPredefinedTypes[prop]
      for (const t of types) {
        if (!(t.value in dic)) {
          dic[t.value] = {
            text: t.text,
            number: 1
          }
        }
        else {
          let n = Number(dic[t.value].number)
          dic[t.value].number = ++n
        }
      }
    }
  })

  const typeKeys = Object.keys(dic)
  for(let i = 0; i < typeKeys.length; i++) {
    const key = typeKeys[i]
    total = total.concat(`${dic[key].number} x ${dic[key].text}`)
    if (i + 1 < typeKeys.length) total = total.concat(" + ")
  }

  return total.length > 0 ? total : t("headers.none")
}

export function getTotalOfTypesForMultipleRowsPreview(prop, parts, t) {
  let total = {
    rows: []
  }
  let dic = {}
  parts
  .forEach(rp => {
    if (rp.diagnosticInfo) {
      const types = rp.diagnosticInfo.pricesOrPredefinedTypes[prop]
      for (const t of types) {
        if (!(t.value in dic)) {
          dic[t.value] = {
            text: t.text,
            number: 1
          }
        }
        else {
          let n = Number(dic[t.value].number)
          dic[t.value].number = ++n
        }
      }
    }
  })

  const typeKeys = Object.keys(dic)
  for(let i = 0; i < typeKeys.length; i++) {
    const key = typeKeys[i]
    total.rows.push(`${dic[key].number} x ${dic[key].text}`)
  }

  // NOTE: if emtpy, set default text.
  if (total.rows.length === 0) total.rows.push(t("headers.none"))

  return total
}